import qs from 'qs'

export const queryEducationPage = () => {
  const query = qs.stringify(
    {
      fields: ['title'],
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `education-page?${query}`
}
